import { EM_DASH } from 'libs.constants';
export const getCountryNameFromCode = (code, countriesOptions = []) => {
    return countriesOptions.find((country) => country.value === code)?.label || EM_DASH;
};
